import script from "./auto-check.vue?vue&type=script&lang=ts&setup=true"
export * from "./auto-check.vue?vue&type=script&lang=ts&setup=true"

import "./auto-check.vue?vue&type=style&index=0&id=6f6619c9&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6619c9"]])

export default __exports__